export const FIREBASE_ERROR = {
  'auth/email-already-in-use':
    'The email address is already in use by another account.',
  'auth/email-already-exists':
    'The email address is already in use by another account.',
  'auth/insufficient-permission':
    'You do not have sufficient permission to access this resource.',
  'auth/internal-error':
    'An internal error occurred while processing the request.',
  'auth/invalid-email':
    'The email address is badly formatted. Please enter a valid email address.',
  'auth/invalid-password': 'The password must be at least 6 characters long.',
  'auth/invalid-phone-number':
    'The phone number must be a non-empty E.164 standard compliant identifier string.',
  'auth/user-not-found':
    'There is no user record corresponding to this identifier. The user may have been deleted.',
  'auth/wrong-password':
    'The password you provided is in correct. Please provide the valid password.',
} as const;
